import { RoleGaurd } from "components/layout/RoleGaurd";
import Btn from "lib/button/Btn";
import React, { useState } from "react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import PropTypes from "prop-types";

import ActionButtons from "./ActionButtons";
import ColumnsFilter from "./ColumnsFilter";
import SearchBox from "./SearchBox";

function TableHeader({
  handleShow,
  selectedCheckbox,
  multiStatusHandler,
  multiDeleteHandler,
  setSearch,
  filterContent,
  tableColumns,
  setTableColumns,
  isFilter,
  defaultShowFilter,
  isDownload,
  addButtonText,
  className,
  isColumn,
  filterData,
  downloadData,
  search,
  module,
}) {
  const [toggle, setToggle] = useState(defaultShowFilter || false);
  const [showDownload, setShowDownload] = useState(false);

  /** *****************   
  @purpose : Used For Tbale header
  @Parameter : {}
  @Author : INIC
  ***************** */

  return (
    <>
      <Row className={`w-100 g-0 ${className}`}>
        <Col md={6}>
          <div className="table-card-header">
            <SearchBox setSearch={setSearch} search={search} className="mt-20" />
            {selectedCheckbox?.length > 0 && (
              <ActionButtons
                module={module}
                multiDeleteHandler={multiDeleteHandler}
                multiStatusHandler={multiStatusHandler}
              />
            )}
          </div>
        </Col>
        <Col md={6}>
          <div className="filter-list flex-start-middle flex-md-end-middle flex-wrap ms-n4">
            {isFilter && (
              <ButtonGroup className="mt-20 ms-4">
                <Btn
                  variant="primary"
                  btnVariant="btn-only-icon"
                  withOnlyIcon="inic inic-filter-1"
                  onClick={() => {
                    setToggle(!toggle);
                    setShowDownload(false);
                  }}
                />
              </ButtonGroup>
            )}
            {isDownload && (
              <RoleGaurd module={module} permission="Download">
                <Btn
                  variant="primary"
                  btnVariant="btn-only-icon"
                  withIconLeft="inic inic-download"
                  className="mt-20 ms-4"
                  onClick={() => {
                    setShowDownload(!showDownload);
                    setToggle(false);
                  }}
                />
              </RoleGaurd>
            )}
            {addButtonText && (
              <RoleGaurd module={module} permission="Create">
                <Btn
                  variant="primary"
                  btnLabel={addButtonText}
                  btnVariant="btn-icon-text"
                  withIconLeft="inic inic-add"
                  className="mt-20 ms-4"
                  onClick={handleShow}
                />
              </RoleGaurd>
            )}
            {isColumn && (
              <ColumnsFilter className="mt-20 ms-4" tableColumns={tableColumns} setTableColumns={setTableColumns} />
            )}
          </div>
        </Col>
        {toggle && <Col sm={12}>{isFilter && filterData}</Col>}
        {showDownload && <Col sm={12}>{isDownload && downloadData}</Col>}
      </Row>
      {isFilter && filterContent}
    </>
  );
}

TableHeader.propTypes = {
  multiStatusHandler: PropTypes.func.isRequired,
  handleShow: PropTypes.func.isRequired,
  selectedCheckbox: PropTypes.arrayOf(PropTypes.bool).isRequired,
  multiDeleteHandler: PropTypes.func.isRequired,
  setSearch: PropTypes.func.isRequired,
  filterContent: PropTypes.node,
  tableColumns: PropTypes.array.isRequired,
  setTableColumns: PropTypes.func.isRequired,
  isFilter: PropTypes.bool.isRequired,
  defaultShowFilter: PropTypes.bool,
  isDownload: PropTypes.bool.isRequired,
  addButtonText: PropTypes.string,
  className: PropTypes.string,
  selectedLanguage: PropTypes.object.isRequired,
  listingAPI: PropTypes.func.isRequired,
  languageKey: PropTypes.string.isRequired,
  isColumn: PropTypes.bool.isRequired,
  isLanguage: PropTypes.bool.isRequired,
  filterData: PropTypes.node,
  downloadData: PropTypes.node,
  search: PropTypes.string.isRequired,
  module: PropTypes.string.isRequired,
};

export default TableHeader;
